window.addEventListener('DOMContentLoaded', () => {
  styleCartSelectors()
})

window.addEventListener('custom::cart-updated', () => {
  styleCartSelectors()
})

function styleCartSelectors() {
  setTimeout(() => { //Needed because was not working on quantity change

    let cartItems = document.querySelectorAll('.js-cart-item')

    if (!!!cartItems) return;

    cartItems.forEach((cartItem, index) => {


      let subscriptionSelector = $(cartItem).find(`[name="cart-item__subscription-select-${cartItem.dataset.itemid}-${cartItem.dataset.sellingplan}"]`);

      subscriptionSelector.off('change');

      subscriptionSelector.select2({
        dropdownParent: subscriptionSelector.closest('.mini-cart__body')
      });

      // Accessibility fixes for Select2 (WCAG 2.1 AA)
      fixCartSelect2Accessibility(cartItem, subscriptionSelector);

      subscriptionSelector.on('change', function () {
        updateSellingPlan(this.value, index + 1, cartItem.querySelector('hh-quantity-input')?._value);
      });

    })

  }, 1);
}

async function updateSellingPlan(sellingPlanId, itemIndex, itemQuantity) {
  try {

    document.querySelector('hh-mini-cart').loading = true

    let payload = {
      'line': itemIndex,
      'quantity': itemQuantity,
      'selling_plan': sellingPlanId
    }

    let sections = "mini-cart,header,cart-notification,main-cart"

    let res = await fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        sections,
        ...payload
      })
    })

    let response = await res.json()

    reRenderShopifySections(response)
    styleCartSelectors()

  } catch (error) {

    console.log(error);

  } finally {

    document.querySelector('hh-mini-cart').loading = false

  }


}

function reRenderShopifySections(response, selector = "[data-rerender]") {

  return Object.keys(response.sections).forEach((key) => {
    const updatedNode = new DOMParser().parseFromString(response.sections[key], "text/html").querySelectorAll(selector);

    document.querySelector(`[id^="shopify-section-"][id*="${key}"]`)?.querySelectorAll(selector).forEach((node, index) => {
      node.replaceWith(updatedNode[index]);
    });
  });
};

function fixCartSelect2Accessibility(cartItem, $selector) {
  const combobox = cartItem.querySelector('[role="combobox"]');
  if (!combobox) return;

  applyCartAriaFixes(cartItem);

  const observer = new MutationObserver(function () {
    applyCartAriaFixes(cartItem);
  });
  observer.observe(cartItem, { attributes: true, subtree: true, attributeFilter: ['aria-controls', 'role'] });

  combobox.addEventListener('keydown', function (e) {
    const isOpen = combobox.getAttribute('aria-expanded') === 'true';

    switch (e.key) {
      case 'ArrowDown':
      case 'ArrowUp': {
        e.preventDefault();
        if (!isOpen) {
          $selector.select2('open');
          setTimeout(function () { highlightCartOption(cartItem, e.key === 'ArrowDown' ? 'first' : 'last'); }, 50);
        } else {
          highlightCartOption(cartItem, e.key === 'ArrowDown' ? 'next' : 'prev');
        }
        break;
      }
      case 'Enter': {
        if (isOpen) {
          e.preventDefault();
          var highlighted = cartItem.querySelector('[data-a11y-highlight="true"]');
          if (highlighted) {
            highlighted.removeAttribute('data-a11y-highlight');
            highlighted.click();
          }
        }
        break;
      }
      case 'Escape': {
        if (isOpen) {
          e.preventDefault();
          cartItem.querySelectorAll('[data-a11y-highlight]').forEach(function (el) { el.removeAttribute('data-a11y-highlight'); });
          $selector.select2('close');
        }
        break;
      }
    }
  });
}

function applyCartAriaFixes(cartItem) {
  const combobox = cartItem.querySelector('[role="combobox"]');
  const listbox = cartItem.querySelector('[role="listbox"]');

  if (combobox && listbox && listbox.id) {
    combobox.setAttribute('aria-controls', listbox.id);
  }

  const renderedSpan = cartItem.querySelector('.select2-selection__rendered[role="textbox"]');
  if (renderedSpan) {
    renderedSpan.removeAttribute('role');
    renderedSpan.removeAttribute('aria-readonly');
  }
}

function highlightCartOption(cartItem, direction) {
  const options = Array.from(cartItem.querySelectorAll('.select2-results__option--selectable'));
  if (!options.length) return;

  const current = cartItem.querySelector('[data-a11y-highlight="true"]');
  let currentIndex = current ? options.indexOf(current) : -1;

  options.forEach(function (opt) {
    opt.removeAttribute('data-a11y-highlight');
    opt.classList.remove('select2-results__option--highlighted');
  });

  var nextIndex;
  switch (direction) {
    case 'first': nextIndex = 0; break;
    case 'last':  nextIndex = options.length - 1; break;
    case 'next':  nextIndex = currentIndex < options.length - 1 ? currentIndex + 1 : 0; break;
    case 'prev':  nextIndex = currentIndex > 0 ? currentIndex - 1 : options.length - 1; break;
  }

  options[nextIndex].setAttribute('data-a11y-highlight', 'true');
  options[nextIndex].classList.add('select2-results__option--highlighted');
  options[nextIndex].scrollIntoView({ block: 'nearest' });

  const combobox = cartItem.querySelector('[role="combobox"]');
  if (combobox && options[nextIndex].id) {
    combobox.setAttribute('aria-activedescendant', options[nextIndex].id);
  }
}